"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility.js");

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _breakdown_table_child_card = require("./breakdown_table_child_card");

var _breakdown_table_child_card2 = _interopRequireDefault(_breakdown_table_child_card);

var _table_of_contents = require("./table_of_contents.js");

var _table_of_contents2 = _interopRequireDefault(_table_of_contents);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _fund_security_lending_config = require("../../../packages/common-utilities/src/fund_security_lending_config.js");

var _ramda = require("ramda");

var _location_service = require("../services/location_service");

var _location_service2 = _interopRequireDefault(_location_service);

var _collection_utility = require("common-utilities/src/collection_utility");

var _security_lending_overview_card = require("./security_lending_overview_card");

var _security_lending_overview_card2 = _interopRequireDefault(_security_lending_overview_card);

var _party_role_name_listing_card = require("./party_role_name_listing_card");

var _party_role_name_listing_card2 = _interopRequireDefault(_party_role_name_listing_card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundSecurityLending = function (_React$PureComponent) {
  _inherits(FundSecurityLending, _React$PureComponent);

  function FundSecurityLending(props) {
    _classCallCheck(this, FundSecurityLending);

    var _this = _possibleConstructorReturn(this, (FundSecurityLending.__proto__ || Object.getPrototypeOf(FundSecurityLending)).call(this, props));

    _this.state = {
      headerTextArray: [],
      headerIdArray: [],
      activeCard: !(0, _ramda.isNil)(_location_service2.default.getNavigateToCardParameter()) ? _location_service2.default.getNavigateToCardParameter() : '',
      isLoading: true,
      triggered: false,
      holdingsCardChanged: false
    };
    _this.goToCard = _this.goToCard.bind(_this);
    _this.activeCardScrollHandler = _this.activeCardScrollHandler.bind(_this);
    _this.renderTableOfContents = _this.renderTableOfContents.bind(_this);
    _this.currentCard = "";
    return _this;
  }

  _createClass(FundSecurityLending, [{
    key: "activeCardScrollHandler",
    value: function activeCardScrollHandler(id) {
      if ((this.props.active === "securities-lending" || this.props.isFlatMode) && this.state.triggered === false) {
        this.setState({
          triggered: true
        });
        return null;
      } else if (this.props.active !== "securities-lending" && !this.props.isFlatMode) {
        this.setState({ triggered: false });
        return null;
      }

      if (!this.state.isLoading && this.state.activeCard !== id) {
        this.setState({ activeCard: id });
      } else {
        this.setState({ isLoading: false });
      }
    }
  }, {
    key: "goToCard",
    value: function goToCard(e) {
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }

      var newState = e.target.getAttribute('data-card-name');
      this.scrollToCard(newState);
      this.setState({ activeCard: newState, isLoading: true });
    }
  }, {
    key: "scrollToCard",
    value: function scrollToCard(cardId) {
      if ((0, _ramda.isNil)(cardId) || !_collection_utility.CollectionUtility.includes(this.state.headerIdArray, cardId)) {
        return;
      }
      var newState = cardId;
      var node = document.getElementById(newState);
      var tocNode = document.querySelector(".toc-" + newState);

      if (node) {
        var stickyHeader = document.querySelector(".sticky-header");
        var headerOffset = stickyHeader ? stickyHeader.offsetHeight - 15 : 120;
        var offset = node.getBoundingClientRect().top - document.body.getBoundingClientRect().top - headerOffset;
        this.props.window.scrollTo({ behavior: 'smooth', top: offset });
      }

      if (tocNode) {
        tocNode.blur();
      }
      this.setState({ activeCard: newState, isLoading: true });
    }
  }, {
    key: "getCardHeaderObjects",
    value: function getCardHeaderObjects() {
      return (0, _jquery2.default)("[data-header='securities-lending-child-header']");
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateTOC(true);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!(0, _ramda.equals)(prevProps.active, this.props.active)) {
        this.updateTOC(true);
      } else if (this.state.activeCard === _location_service2.default.getNavigateToCardParameter() && this.currentCard !== _location_service2.default.getNavigateToCardParameter()) {
        this.scrollToCard(this.state.activeCard);
        this.currentCard = _location_service2.default.getNavigateToCardParameter();

        var pathName = this.props.window.location.pathname + '#/securities-lending';
        this.props.window.history.replaceState("securities-lending", "securities-lending", pathName);
      }
    }
  }, {
    key: "updateTOC",
    value: function updateTOC(setDefault) {
      var newHeaderTextArray = [];
      var newHeaderIdArray = [];
      var allCardHeaders = this.getCardHeaderObjects();

      for (var i = 0; i < allCardHeaders.length; i++) {
        newHeaderTextArray.push(allCardHeaders[i].innerText);
        newHeaderIdArray.push(allCardHeaders[i].id);
      }
      this.setState({
        headerTextArray: newHeaderTextArray, headerIdArray: newHeaderIdArray, isLoading: false
      });
      if (!(0, _ramda.isNil)(_location_service2.default.getNavigateToCardParameter())) {
        this.setState({
          activeCard: _location_service2.default.getNavigateToCardParameter()
        });
      } else if (setDefault) {
        this.setState({
          activeCard: newHeaderIdArray[0]
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var configs = (0, _fund_security_lending_config.getFundSecurityLendingConfig)(this.props);
      return _react2.default.createElement(
        "div",
        null,
        this.renderTableOfContents(),
        this.renderChildCards(configs),
        _react2.default.createElement("div", {
          className: "col-md-12",
          id: "toc-sticky-stopper",
          style: { float: "left" }
        })
      );
    }
  }, {
    key: "renderTableOfContents",
    value: function renderTableOfContents() {
      var _props = this.props,
          breakpoint = _props.breakpoint,
          active = _props.active;

      if (breakpoint < 3 || active !== "securities-lending" && !this.props.isFlatMode) {
        return null;
      }

      return _react2.default.createElement(
        "div",
        {
          className: "xs-hidden sm-hidden col-md-3 col-lg-3 col-xlg-3 margin-left-0 print-hide",
          id: "table-of-content-parent",
          style: { float: "left" }
        },
        _react2.default.createElement(_table_of_contents2.default, {
          id: "securities-lending",
          headerIdArray: this.state.headerIdArray,
          headerTextArray: this.state.headerTextArray,
          activeCard: this.state.activeCard,
          goToCard: this.goToCard,
          scrollPosition: this.props.scrollPosition,
          window: this.props.window,
          testTopPosition: this.props.testTopPosition,
          isFlatMode: this.props.isFlatMode
        })
      );
    }
  }, {
    key: "renderChildCards",
    value: function renderChildCards(configs) {
      var _this2 = this;

      var visibleSecurityLendingCards = ['securitiesLendingOverviewData', 'securitiesLendingData', 'topPositionsOfSecuritiesHeldAsCollateral', 'securityLendingApprovedBorrowers', 'collateralRequirement'];
      return _react2.default.createElement(
        "div",
        {
          className: "col-xs-12 col-sm-12 col-lg-9 col-xlg-9 " + _functional_utility2.default.conditionCheck(this.props.breakpoint > 3, "col-md-9", "") + " print-full-width print-display",
          id: "securities-lending-container" },
        visibleSecurityLendingCards.map(function (item) {
          return _this2.renderChildCardsFromConfig(configs[item]);
        })
      );
    }
  }, {
    key: "renderChildCardsFromConfig",
    value: function renderChildCardsFromConfig(config) {
      switch (config.type) {
        case "securityLendingChild":
          return _react2.default.createElement(_breakdown_table_child_card2.default, {
            componentId: "securities-lending",
            key: config.id,
            country: this.props.country,
            role: this.props.role,
            numberFormat: this.props.fund.numberFormat,
            activeTab: this.props.active,
            tooltip: this.props.tooltip,
            breakpoint: this.props.breakpoint,
            activeCardHandler: this.activeCardScrollHandler,
            breakdown: config.breakdown,
            header: config.header,
            id: config.id,
            gaiaRedirectUrl: this.props.gaiaRedirectUrl,
            cusip: this.props.cusip,
            disclosureText: config.disclosureText,
            placementId: config.placementId,
            grouping: (0, _ramda.pathOr)(false, ["grouping"], config),
            disclosures: config.disclosures,
            subColumnHeader: config.subColumnHeader,
            effectiveDate: config.effectiveDate,
            visibleDataPoints: this.props.fund.visibleData.visibleDataPoints,
            showDashOn2ndColumn: config.showDashOn2ndColumn !== "false",
            excelDownloadType: config.excelDownloadType,
            shouldAlwaysShowMore: !(0, _functional_utility.isNilOrEmpty)(config.shouldAlwaysShowMore) ? config.shouldAlwaysShowMore : false
          });
        case "securityLendingOverviewCard":
          return _react2.default.createElement(_security_lending_overview_card2.default, {
            headerLabel: config.header,
            pdpCardSecuritiesLending: this.props.fund.disclosures.pdpCardSecuritiesLending,
            breakpoint: this.props.breakpoint,
            cusip: this.props.cusip,
            pdpCardSecuritiesLendingFeeSplit: this.props.fund.disclosures.pdpCardSecuritiesLendingFeeSplit,
            content: this.props.content,
            activeCardHandler: this.activeCardScrollHandler,
            componentId: "securities-lending",
            id: config.id
          });
        case "securityLendingApprovedBorrowersCard":
          return _react2.default.createElement(_party_role_name_listing_card2.default, {
            data: config.data,
            breakpoint: this.props.breakpoint,
            id: config.id,
            headerTitle: config.header,
            headerTitleId: "securities-lending-child-header",
            activeCardHandler: this.activeCardScrollHandler,
            componentId: "securities-lending"
          });
        default:
          return null;
      }
    }
  }]);

  return FundSecurityLending;
}(_react2.default.PureComponent);

exports.default = FundSecurityLending;